import { type InfiniteData } from '@tanstack/react-query';
import { flatMap } from 'lodash';

import { type Board } from '@air/api/types';

type BoardsListPage = {
  data: Board[];
  total?: number;
  pagination?: { cursor: string | null };
};

export const formatBoardsListResponse = (data: InfiniteData<BoardsListPage> | undefined) => {
  return {
    boards: flatMap(data?.pages, (page) => page.data),
    boardsTotal: data?.pages?.[0]?.total,
  };
};
